import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import SecondaryLinkItemComponent from "segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component";
import { getMiniSiteLinks } from "client/services/cluster-config-service/cluster-config-service";
import { isSameUrlWithoutQueryParams } from "utils/url";
import { withRouter } from "next/router";
import { isNodeFullyInView } from "services/dom-utils-service";
import { StyledSecondaryHeaderMobileComponent } from "./secondary-header-mobile-component.scss";
import { getLocalizedUri } from "constants/localized-links";
const SCROLL_TRESHOLD = 10;
const INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK = 64;
const SecondaryHeaderMobileComponent = (props)=>{
    const [isScrollEnded, setIsScrollEnded] = useState(false);
    const selectedLinkRef = useRef(null);
    const linksWrapperRef = useRef(null);
    const { pageClusterConfig, router, useProductMiniSiteConfig } = props;
    const [linksWrapperScrollWidth, setLinksWrapperScrollWidth] = useState(null);
    const [linksWrapperOffsetWidth, setLinksWrapperOffsetWidth] = useState(null);
    useEffect(()=>{
        if (selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current) {
            isNodeFullyInView(selectedLinkRef === null || selectedLinkRef === void 0 ? void 0 : selectedLinkRef.current).then((inView)=>{
                if (!inView) {
                    selectedLinkRef.current.scrollIntoView(true);
                    linksWrapperRef.current.scrollLeft += INITIAL_SCROLL_FOR_OUTER_VIEWPORT_LINK;
                }
            });
        }
        linksWrapperRef.current.addEventListener("scroll", scrollListenerForSecondaryMenuRemoveFade, {
            passive: true
        });
    }, []);
    useEffect(()=>{
        var _linksWrapperRef_current, _linksWrapperRef_current1;
        setLinksWrapperScrollWidth((_linksWrapperRef_current = linksWrapperRef.current) === null || _linksWrapperRef_current === void 0 ? void 0 : _linksWrapperRef_current.scrollWidth);
        setLinksWrapperOffsetWidth((_linksWrapperRef_current1 = linksWrapperRef.current) === null || _linksWrapperRef_current1 === void 0 ? void 0 : _linksWrapperRef_current1.offsetWidth);
    }, [
        linksWrapperRef
    ]);
    const scrollListenerForSecondaryMenuRemoveFade = ()=>{
        const scrollLeft = linksWrapperRef.current.scrollLeft;
        if (scrollLeft + SCROLL_TRESHOLD >= linksWrapperScrollWidth - linksWrapperOffsetWidth) {
            setIsScrollEnded(true);
        } else if (isScrollEnded) {
            setIsScrollEnded(false);
        }
    };
    const scrollToLinkItemOnClick = (e)=>{
        e.target.scrollIntoView(true);
    };
    const renderLinks = ()=>{
        const { localeId } = props;
        const links = getMiniSiteLinks(pageClusterConfig, {
            useProductMiniSiteConfig
        });
        return links.map((link, index)=>{
            const isSelected = isSameUrlWithoutQueryParams(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath);
            return /*#__PURE__*/ _jsx("div", {
                className: "secondary-link-item-wrapper",
                ref: isSelected ? selectedLinkRef : null,
                onClick: scrollToLinkItemOnClick,
                children: /*#__PURE__*/ _jsx(SecondaryLinkItemComponent, {
                    url: getLocalizedUri(link === null || link === void 0 ? void 0 : link.url, localeId),
                    title: link === null || link === void 0 ? void 0 : link.text,
                    isSelected: isSelected
                })
            }, index);
        });
    };
    return /*#__PURE__*/ _jsx(StyledSecondaryHeaderMobileComponent, {
        "aria-label": "Secondary",
        className: classnames("secondary-header-mobile-component", {
            "scroll-end": isScrollEnded
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: "links-wrapper",
            ref: linksWrapperRef,
            children: renderLinks()
        })
    });
};
export default withRouter(withGenericConfig(SecondaryHeaderMobileComponent));
